import React from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {CardShopRepository} from "../Repository/CardShopRepository";
import {CardShopStructList} from "../structs/CardShopStructList";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import {Snackbar} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Typography from "@mui/material/Typography";
import {BackButton, BottomMenu} from './HookUtils'
import {Link, useNavigate} from "react-router-dom";
import Location from "../assets/icons/location.svg";
import EmptyShopCard from "../assets/icons/empty_shopcard.jpg";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AvatarRound from "../assets/icons/avatar_round.svg";
import {safeAdd, safeMultiply} from './mathUtils';
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Zoom2 from '@mui/material/Zoom';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export class CardShopComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cardShopList: [],
            totalOrder: 0,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            userData: null,
            units: props.units_prop,
        }

    }

    componentDidMount() {
        this.getCardShop()
        this.getUserData()
    }


    getUserData() {
        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        this.setState({userData: results.data, name: results.data.name, address: results.data.address})
                    }
                },
                (error) => {
                    console.log("error")

                }
            );
    }

    getCardShop() {
        if (CardShopRepository.getAll() !== null) {
            let cardShopList = []

            CardShopRepository.getAll().forEach(function (item) {
                let check = false;

                cardShopList.forEach(function (item2) {
                    if (item.product.markets.id === item2.market.id) {

                        if (item.product.price > 0) {
                            item2.total += (parseInt(item.product.price) - parseInt(item.product.del_price)) * item.count
                        }

                        item2.productList.push(item)
                        check = true
                    }
                })


                if (!check) {
                    let cardShopStructList = new CardShopStructList()
                    cardShopStructList.market = item.product.markets

                    if (item.product.price > 0) {
                        cardShopStructList.total += (parseInt(item.product.price) - parseInt(item.product.del_price)) * item.count
                    }

                    cardShopStructList.productList.push(item)

                    cardShopList.push(cardShopStructList)
                }
            })

            let sum = 0;
            cardShopList.forEach(function (item) {
                sum += (parseFloat(item.total) /*+ parseFloat(item.market.shipping)*/)
            })

            this.setState({totalOrder: sum})

            this.setState({cardShopList: cardShopList})
        }

    }

    render() {
        const handleOnInputChange = (item) => {
            let newCount = parseFloat(item.tempCount ?? item.count);

            if (isNaN(newCount) || newCount < 0) {
                this.setState({openSnackbar: true, message: "تعداد معتبر وارد کنید!", snackbarType: "error"});
                return;
            }

            if (newCount === 0) {
                CardShopRepository.removeItem(item.product.id);
                this.getCardShop();
                return;
            }

            if (newCount > parseFloat(item.product.step)) {
                this.setState({openSnackbar: true, message: "موجودی کالا کافی نیست!", snackbarType: "error"});
                return;
            }

            if (item.product.price > 0) {
                // آپدیت تعداد در کارت
                const currentCount = CardShopRepository.getItem(item.product.id)?.count || 0;
                if (newCount > currentCount) {
                    for (let i = 0; i < newCount - currentCount; i++) {
                        CardShopRepository.updateCount(item.product, parseFloat(item.count) + 1);
                        item.count = parseFloat(item.count) + 1;
                    }

                } else if (newCount < currentCount) {
                    for (let i = 0; i < currentCount - newCount; i++) {
                        CardShopRepository.updateCount(item.product, parseFloat(item.count) - 1);
                        item.count = parseFloat(item.count) - 1;

                    }
                }
                item.count = newCount;
            } else {
                this.setState({openSnackbar: true, message: "جهت خرید کالا تماس بگیرید.", snackbarType: "error"});
                return;
            }

            delete item.tempCount;
            this.setState({});
        };


        const MAX_LENGTH = 50;
        const onPaymentCLicked = () => {
            const list = CardShopRepository.getAll();

            if (this.state.name === null || this.state.name === "") {
                this.setState({
                    openSnackbar: true,
                    message: "ابتدا نام و نام خانوادگی را تکمیل کنید!",
                    snackbarType: "error"
                })
                return
            }

            if (this.state.address === null || this.state.address === "") {
                this.setState({
                    openSnackbar: true,
                    message: "ابتدا آدرس خودرا از منوی پروفایل تکمیل کنید!",
                    snackbarType: "error"
                })
                return
            }
            if (this.state.name === null || this.state.name === "") {
                this.setState({openSnackbar: true, message: "نام و نام خانوادگی را وارد کنید!", snackbarType: "error"})
            }
            if (list !== null) {
                let products = CardShopRepository.getAll()[0].product.id;
                let counts = CardShopRepository.getAll()[0].count;

                if (list.length > 1) {
                    for (let i = 1; i < list.length; i++) {
                        products += "," + list[i].product.id;
                        counts += "," + list[i].count;
                    }
                }

                fetch(BASE_URL_API + 'order', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        products: products.toString(),
                        counts: counts.toString(),
                        user_agent: "pwa"
                    })
                })


                    .then(response => response.json())
                    .then(result => {
                        if (result.code === 200) {

                            this.setState({openSnackbar: true, message: "در حال انتقال به درگاه پرداخت..."})

                            redirectToSepehr(result)
                            //  window.location.assign(result.data);
                        } else {
                            this.setState({openSnackbar: true, message: result.message, snackbarType: "error"})
                        }


                    })
            }


        };

        const redirectToSepehr = (data) => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = data.redirect_url;

            const fields = {
                TerminalID: data.merchant_id,
                token: data.token,
                getMethod: '1'
            };

            Object.keys(fields).forEach(key => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
        };

        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }
        const MAX_LENGTH_ADDRESS = 200;

        function onConfirmOrder(id) {

        }

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>

                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }}>{"سبد خرید"}</strong>
                        </ListItemText>


                        <BackButton/>

                    </ToolbarMui>

                </AppBar>
                {
                    this.state.userData !== null ?
                        <div style={{background: '#f5f5f5', marginTop: 65, padding: 32}} alignItems='center'
                             justifyContent='center' align='center'>

                            <div style={{display: 'flex'}}>
                                <img style={{width: 28, height: 28, marginTop: 8}} alt="avatar2" src={AvatarRound}/>

                                <Typography style={{
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    flex: 12
                                }} align='right'><p style={{
                                    fontSize: 14,
                                    overflow: 'ellipsis',
                                    paddingRight: 8,
                                    color: 'black'
                                }}>{"نام و نام خانوادگی: ‌" + this.state.userData.name}</p>
                                </Typography>
                                <IconButton component={Link} to={"/profile"} size="large"><BorderColorIcon
                                    style={{color: 'black'}}/></IconButton>
                            </div>

                            <div style={{display: 'flex'}}>
                                <img style={{width: 24, height: 24, marginTop: 8}} alt="avatar2" src={Location}/>

                                <Typography style={{
                                    overflow: 'ellipsis',
                                    whiteSpace: 'pre-line',
                                    wordWrap: "break-word",
                                    color: 'black',
                                    fontWeight: 'bold',
                                    flex: 12
                                }} align='right'><p style={{
                                    fontSize: 14,
                                    whiteSpace: 'pre-line',
                                    wordWrap: "break-word",
                                    paddingRight: 8,
                                    color: 'black'
                                }}>{"ارسال به: ‌" + this.state.userData.address}</p>
                                </Typography>
                            </div>
                        </div> : ''
                }
                {this.state.cardShopList === null || this.state.cardShopList.length === 0 ? (
                    <div align='center'>
                        <img style={{width: '20%'}} alt="avatar2" src={EmptyShopCard}/>
                    </div>

                ) : ''}
                <List> {this.state.cardShopList.map((item) => (

                    <ListItem style={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{maxWidth: 500}}>
                            <Paper>
                                <ListItemText style={{align: 'right'}}>

                                    <Grid container>
                                        <Grid item xs={6}>
                                            <p style={{
                                                marginRight: 12,
                                                overflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                color: 'green',
                                                fontWeight: 'bold'
                                            }}
                                               align='right'>{item.market.name}
                                            </p>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <p
                                                style={{
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    color: "gray",
                                                    fontSize: 12,
                                                    textAlign: "center",
                                                }}
                                            >
                                                {`هزینه ارسال: ${"پس کرایه"}`}
                                            </p>
                                        </Grid>

                                        {item.productList.map((item) => (
                                            <React.Fragment>
                                                <Grid item xs={2}>
                                                    <Paper
                                                        style={{
                                                            width: 45,
                                                            height: 45,
                                                            marginRight: 15,
                                                            marginBottom: 15,
                                                            align: 'center',
                                                            backgroundPosition: 'center',
                                                        }}>
                                                        <img style={{
                                                            width: 45,
                                                            height: 45,
                                                            objectFit: 'cover'
                                                        }}
                                                             src={item.product.pictures.length > 0 ? PRODUCT_BASE_URL_API + item.product.pictures[0].url : "hamekara-logo.png"}/>

                                                    </Paper>
                                                    <p style={{
                                                        overflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        color: 'gray',
                                                        marginRight: 15,
                                                        fontSize: 12
                                                    }}>
                                                        {"قیمت: " + (item.product.price || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('fa-IR') + " تومان"}
                                                    </p>
                                                </Grid>
                                                {item.product.title.length > MAX_LENGTH ?
                                                    (
                                                        <Grid item xs={4}>
                                                            <p style={{
                                                                overflow: 'ellipsis', whiteSpace: 'pre-line',
                                                                wordWrap: "break-word", fontSize: 12
                                                            }}
                                                               align='center'>{`${item.product.title.substring(0, MAX_LENGTH)}...`}</p>
                                                        </Grid>
                                                    ) :
                                                    <Grid item xs={4}>
                                                        <p style={{
                                                            overflow: 'ellipsis', whiteSpace: 'pre-line',
                                                            wordWrap: "break-word", fontSize: 12
                                                        }}
                                                           align='center'>{`${item.product.title}`}</p>
                                                    </Grid>

                                                }

                                                <Grid item xs={2}>
                                                    {(() => {
                                                        const unit = this.state.units.find(unit => unit.id === item.product.unit_id);
                                                        return (
                                                            <p style={{
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                fontSize: 12
                                                            }} align="center">
                                                                {unit ? `${unit.unit_type} ${item.count} ${unit.name}` : `${item.count}`}
                                                            </p>
                                                        );
                                                    })()}
                                                </Grid>

                                                {
                                                    item.product.price > 0 ?
                                                        <Grid item xs={4}>
                                                            <p style={{
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                fontSize: 12
                                                            }} align='center'>
                                                                {"مجموع: " +
                                                                parseInt((item.count || 0) *
                                                                    (parseFloat(item.product.price || 0) - parseFloat(item.product.del_price || 0)))
                                                                    .toString()
                                                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}
                                                            </p>
                                                        </Grid>
                                                        :
                                                        <Grid item xs={3}>
                                                            <p style={{
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                fontSize: 12
                                                            }} align='center'>{" تماس بگیرید "}</p>
                                                        </Grid>
                                                }


                                                <Grid
                                                    item
                                                    xs={20}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "8px",
                                                        marginTop: "8px"
                                                    }}
                                                >
                                                    {/* دکمه کاهش */}
                                                    {/* دکمه کاهش */}
                                                    <IconButton
                                                        color="inherit"
                                                        aria-label="decrease"
                                                        edge="end"
                                                        onClick={() => {
                                                            if (!item?.product) return; // اطمینان از وجود محصول

                                                            const numResult = (parseFloat(item.count) - 1).toFixed(3); // "3.555" as a string
                                                            const result = parseFloat(numResult); // 3.555 as a number

                                                            var newCount = Math.max(0, result);

                                                            if (newCount === 0) {
                                                                // ✅ حذف همان محصول از Repository
                                                                CardShopRepository.removeItem(item.product.id);

                                                                // ✅ حذف فقط همین محصول از state (نه کل مارکت)
                                                                this.setState(prev => {
                                                                    const updatedList = prev.cardShopList.map(market => {
                                                                        // اگر market شامل این محصول باشد، آن را از productList فیلتر کن
                                                                        return {
                                                                            ...market,
                                                                            productList: (market.productList || []).filter(
                                                                                p => p?.product?.id !== item.product.id
                                                                            )
                                                                        };
                                                                    }).filter(market => (market.productList || []).length > 0);
                                                                    // فقط مارکت‌هایی که هنوز محصول دارند باقی بمانند

                                                                    const totalOrder = this.state.cardShopList.reduce((sumMarket, market) => {
                                                                        return safeAdd(
                                                                            sumMarket,
                                                                            (market.productList || []).reduce((sumProduct, p) => {
                                                                                const price = parseFloat(p?.product?.price || 0) - parseFloat(p?.product?.del_price || 0);
                                                                                const qty = parseFloat(p?.count || 0);
                                                                                const lineTotal = safeMultiply(qty, price, 6); // دقت ۶ رقم
                                                                                return safeAdd(sumProduct, lineTotal, 6);
                                                                            }, 0),
                                                                            6
                                                                        );
                                                                    }, 0);

                                                                    return {
                                                                        cardShopList: updatedList,
                                                                        totalOrder: parseInt(totalOrder)
                                                                    };
                                                                });
                                                            } else {
                                                                // کاهش تعداد در Repository
                                                                CardShopRepository.updateCount(item.product, newCount);
                                                                item.count = newCount;
                                                                const totalOrder = this.state.cardShopList.reduce((sumMarket, market) => {
                                                                    return safeAdd(
                                                                        sumMarket,
                                                                        (market.productList || []).reduce((sumProduct, p) => {
                                                                            const price = parseFloat(p?.product?.price || 0) - parseFloat(p?.product?.del_price || 0);
                                                                            const qty = parseFloat(p?.count || 0);
                                                                            const lineTotal = safeMultiply(qty, price, 6); // دقت ۶ رقم
                                                                            return safeAdd(sumProduct, lineTotal, 6);
                                                                        }, 0),
                                                                        6
                                                                    );
                                                                }, 0);

                                                                this.setState({totalOrder: parseInt(totalOrder)});
                                                            }
                                                        }}
                                                        sx={{
                                                            ...(this.state.open && {display: "none"}),
                                                            width: 48,
                                                            height: 48
                                                        }}
                                                        size="large"
                                                    >
                                                        <RemoveCircleOutlineIcon sx={{fontSize: 32, color: "red"}}/>
                                                    </IconButton>


                                                    {/* input عددی */}

                                                    <input type="text" value={item.count} style={{
                                                        width: 100,
                                                        direction: "rtl",     // ✅ جهت نوشتار راست‌به‌چپ
                                                        textAlign: "right",   // ✅ متن/عدد کاملاً راست‌چین
                                                        padding: 6,
                                                        borderRadius: 8,
                                                        border: "1px solid #ccc",
                                                        fontSize: 14,
                                                    }}

                                                           onChange={(e) => {
                                                               let val = e.target.value;

                                                               // جلوگیری از وارد کردن حروف
                                                               if (!/^\d*\.?\d*$/.test(val)) return;
                                                               // اگر با نقطه شروع شد، جلوی آن 0 اضافه شود


                                                               const units = JSON.parse(localStorage.getItem("productUnitsCache")) || [];
                                                               const selectedUnit = units.find(u => u.id === item.product.unit_id);
                                                               const dataType = selectedUnit?.data_type;

                                                               // ✅ اگر نوع int باشد → نقطه رو حذف کنیم (اعشاری نباشه)
                                                               if (dataType === "int" && val.includes(".")) {
                                                                   val = val.split(".")[0];
                                                               }

                                                               // ✅ اگر float باشد → بیشتر از دو رقم اعشار مجاز نباشه
                                                               if (dataType === "float") {
                                                                   if (val.includes(".")) {
                                                                       const [intPart, decPart] = val.split(".");
                                                                       if (decPart.length > 3) return; // حداکثر دو رقم بعد اعشار
                                                                   }
                                                                   // اجازه بده رشته شامل نقطه باشه و parseFloat فقط برای محاسبه و repository استفاده شود
                                                                   item.count = val;
                                                                   this.setState({});
                                                                   return; // این return مهمه، اجازه میده کاربر ادامه بده و عدد کامل وارد کنه
                                                               }

                                                               // اگر خالی بود یا "." بود، مقدار خالی بمونه
                                                               if (val === "" || val === ".") {
                                                                   item.count = val;
                                                                   this.setState({});
                                                                   return;
                                                               }

                                                               // تبدیل به عدد
                                                               let numVal = parseFloat(val);
                                                               if (isNaN(numVal) || numVal < 0) {
                                                                   this.setState({
                                                                       openSnackbar: true,
                                                                       message: "تعداد معتبر وارد کنید!",
                                                                       snackbarType: "error",
                                                                   });
                                                                   return;
                                                               }
                                                               // محدودیت موجودی

                                                               if (numVal > parseFloat(item.product.step)) {
                                                                   this.setState({
                                                                       openSnackbar: true,
                                                                       message: "موجودی کالا کافی نیست!",
                                                                       snackbarType: "error",
                                                                   });
                                                                   numVal = parseFloat(item.product.step);
                                                               }

                                                               // محدود کردن به 2 رقم اعشار (در صورت float)
                                                               if (dataType === "float") {
                                                                   numVal = parseFloat(numVal.toFixed(3));
                                                               }


                                                               const maxVal = parseFloat(item.product.step);
                                                               if (numVal > maxVal) numVal = maxVal;

                                                               // محدود کردن طول عدد

                                                               // ✅ ست کردن مقدار نهایی
                                                               item.count = numVal;
                                                               this.setState({});

                                                               // ✅ آپدیت Repository
                                                               CardShopRepository.updateCount(item.product, numVal);

                                                               // ✅ محاسبه مجموع کل سفارش
                                                               const totalOrder = this.state.cardShopList.reduce((sumMarket, market) => {
                                                                   return safeAdd(
                                                                       sumMarket,
                                                                       (market.productList || []).reduce((sumProduct, p) => {
                                                                           const price = parseFloat(p?.product?.price || 0) - parseFloat(p?.product?.del_price || 0);
                                                                           const qty = parseFloat(p?.count || 0);
                                                                           const lineTotal = safeMultiply(qty, price, 6); // دقت ۶ رقم
                                                                           return safeAdd(sumProduct, lineTotal, 6);
                                                                       }, 0),
                                                                       6
                                                                   );
                                                               }, 0);

                                                               this.setState({totalOrder: parseInt(totalOrder)});


                                                           }}


                                                           onBlur={() => {
                                                               if (item.count === "" || item.count === ".") return;

                                                               const units = JSON.parse(localStorage.getItem("productUnitsCache")) || [];
                                                               const selectedUnit = units.find(u => u.id === item.product.unit_id);
                                                               const dataType = selectedUnit?.data_type;

                                                               let val = parseFloat(item.count);

                                                               if (isNaN(val) || val < 0) {
                                                                   this.setState({
                                                                       openSnackbar: true,
                                                                       message: "تعداد معتبر وارد کنید!",
                                                                       snackbarType: "error",
                                                                   });
                                                                   item.count = "";
                                                                   return;
                                                               }

                                                               // ✅ اگر نوع int باشد → تبدیل به عدد صحیح
                                                               if (dataType === "int") {
                                                                   val = Math.floor(val); // فقط قسمت صحیح
                                                               }

                                                               // ✅ اگر float باشد → محدود به 2 رقم اعشار
                                                               if (dataType === "float") {
                                                                   val = parseFloat(val.toFixed(3));
                                                               }


                                                               if (val > parseFloat(item.product.step)) {
                                                                   this.setState({
                                                                       openSnackbar: true,
                                                                       message: "موجودی کالا کافی نیست!",
                                                                       snackbarType: "error",
                                                                   });
                                                                   val = parseFloat(item.product.step);
                                                               }

                                                               item.count = val;
                                                               this.setState({});


                                                               // ✅ به روزرسانی Repository
                                                               CardShopRepository.updateCount(item.product, val);

                                                               const totalOrder = this.state.cardShopList.reduce((sumMarket, market) => {
                                                                   return safeAdd(
                                                                       sumMarket,
                                                                       (market.productList || []).reduce((sumProduct, p) => {
                                                                           const price = parseFloat(p?.product?.price || 0) - parseFloat(p?.product?.del_price || 0);
                                                                           const qty = parseFloat(p?.count || 0);
                                                                           const lineTotal = safeMultiply(qty, price, 6); // دقت ۶ رقم
                                                                           return safeAdd(sumProduct, lineTotal, 6);
                                                                       }, 0),
                                                                       6
                                                                   );
                                                               }, 0);

                                                               this.setState({totalOrder: parseInt(totalOrder)});

                                                               // ✅ حذف محصول بعد از 1. ثانیه اگر صفر شد
                                                               if (val === 0) {
                                                                   setTimeout(() => {
                                                                       CardShopRepository.removeItem(item.product.id);
                                                                       this.setState(prev => ({
                                                                           cardShopList: prev.cardShopList.map(market => ({
                                                                               ...market,
                                                                               productList: (market.productList || []).filter(p => p.product.id !== item.product.id)
                                                                           })).filter(market => (market.productList || []).length > 0), // فقط مارکتی که محصول داره بمونه
                                                                           totalOrder: prev.cardShopList
                                                                               .map(market => ({
                                                                                   ...market,
                                                                                   productList: (market.productList || []).filter(p => p.product.id !== item.product.id)
                                                                               }))
                                                                               .reduce((sumMarket, market) => sumMarket + (market.productList || []).reduce((sumProduct, p) => {
                                                                                   const price = parseFloat(p?.product?.price || 0) - parseFloat(p?.product?.del_price || 0);
                                                                                   return sumProduct + (parseFloat(p?.count || 0) * (price > 0 ? price : 0));
                                                                               }, 0), 0)
                                                                       }));
                                                                   }, 100);
                                                               }

                                                           }}
                                                    />

                                                    {/* دکمه افزایش */}
                                                    <IconButton
                                                        color="inherit"
                                                        aria-label="increase"
                                                        edge="end"
                                                        onClick={() => {
                                                            let currentCount = parseFloat(item.count);
                                                            const maxCount = parseFloat(item.product.step);

                                                            if (currentCount < maxCount) {
                                                                if (item.product.price > 0) {
                                                                    // افزایش مقدار و محدود کردن به 3 رقم اعشار
                                                                    currentCount = parseFloat((currentCount + 1).toFixed(3));

                                                                    // اگر بعد از افزایش بیشتر از موجودی شد، آن را به موجودی محدود کن
                                                                    if (currentCount > maxCount) currentCount = maxCount;

                                                                    // به Repository اضافه کن
                                                                    CardShopRepository.updateCount(item.product, currentCount);
                                                                    item.count = currentCount;


                                                                    // محاسبه totalOrder
                                                                    const totalOrder = this.state.cardShopList.reduce((sumMarket, market) => {

                                                                        return safeAdd(
                                                                            sumMarket,
                                                                            (market.productList || []).reduce((sumProduct, p) => {
                                                                                const price = parseFloat(p?.product?.price || 0) - parseFloat(p?.product?.del_price || 0);
                                                                                const qty = parseFloat(p?.count || 0);
                                                                                const lineTotal = safeMultiply(qty, price, 6); // دقت ۶ رقم
                                                                                return safeAdd(sumProduct, lineTotal, 6);
                                                                            }, 0),
                                                                            6
                                                                        );
                                                                    }, 0);

                                                                    this.setState({totalOrder: parseInt(totalOrder)});
                                                                } else {
                                                                    this.setState({
                                                                        openSnackbar: true,
                                                                        message: "جهت خرید کالا تماس بگیرید.",
                                                                        snackbarType: "error"
                                                                    });
                                                                }
                                                            } else {
                                                                this.setState({
                                                                    openSnackbar: true,
                                                                    message: "موجودی کالا به اتمام رسیده!",
                                                                    snackbarType: "error"
                                                                });
                                                            }
                                                        }}
                                                        size="large"
                                                    >
                                                        <AddCircleIcon sx={{fontSize: 32, color: "green"}}/>
                                                    </IconButton>
                                                </Grid>


                                            </React.Fragment>
                                        ))
                                        }

                                        <Grid xs={12} style={{width: '100%', background: 'green'}}>
                                            <p style={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                paddingRight: 12,
                                                fontSize: 12,
                                                color: 'white'
                                            }} align='right'>
                                                {"مجموع: " +
                                                parseInt((item.productList?.reduce((sum, p) => {
                                                    const price = parseFloat(p.product.price || 0) - parseFloat(p.product.del_price || 0);
                                                    return sum + (parseFloat(p.count || 0) * (price > 0 ? price : 0));
                                                }, 0) || 0) /*+ parseFloat(item.market?.shipping || 0)*/)
                                                    .toString()
                                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان"}
                                            </p>
                                        </Grid>

                                    </Grid>

                                </ListItemText>
                            </Paper>
                        </div>
                    </ListItem>

                ))
                }
                </List>
                {
                    this.state.cardShopList.length > 0 ? (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                direction: 'rtl',
                                paddingBottom: 90,
                            }}
                        >
                            <Tooltip
                                title="⚠️ فیلترشکن خود را قبل از اتصال به درگاه خاموش کنید."
                                placement="top"
                                arrow
                                open={true}          // 👈 Always show tooltip
                                TransitionComponent={Zoom2} // smooth animation
                            >
                                <Button
                                    onClick={() => onPaymentCLicked()}
                                    variant="contained"
                                    style={{
                                        color: 'white',
                                        margin: '40px 0 10px 0',
                                        background: 'green',
                                        padding: '10px 30px',
                                        fontSize: '16px',
                                        borderRadius: '8px'
                                    }}
                                >
                                    {`تکمیل سفارش (${(
                                        parseInt(
                                            this.state.totalOrder +
                                            this.state.cardShopList.reduce(
                                                (sum, item) => sum /* + parseFloat(item.market?.shipping || 0) */,
                                                0
                                            )
                                        )
                                    )
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان)`}
                                </Button>
                            </Tooltip>
                        </div>

                    ) : null}

                <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
                <BottomMenu/>
            </React.Fragment>
        );

    }

}
